var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#464B52",
    fillRule: "evenodd",
    d: "M3.5 4a.5.5 0 0 1 0-1H13v9.5a.5.5 0 0 1-1 0V4.707l-8.146 8.147a.5.5 0 0 1-.708-.708L11.293 4H3.5Z",
    clipRule: "evenodd"
  })));
};
export { SvgExternalLink as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMy41IDRDMy4yMjM4NiA0IDMgMy43NzYxNCAzIDMuNUMzIDMuMjIzODYgMy4yMjM4NiAzIDMuNSAzSDEzVjEyLjVDMTMgMTIuNzc2MSAxMi43NzYxIDEzIDEyLjUgMTNDMTIuMjIzOSAxMyAxMiAxMi43NzYxIDEyIDEyLjVWNC43MDcxMUwzLjg1MzU1IDEyLjg1MzZDMy42NTgyOSAxMy4wNDg4IDMuMzQxNzEgMTMuMDQ4OCAzLjE0NjQ1IDEyLjg1MzZDMi45NTExOCAxMi42NTgzIDIuOTUxMTggMTIuMzQxNyAzLjE0NjQ1IDEyLjE0NjRMMTEuMjkyOSA0SDMuNVoiIGZpbGw9IiM0NjRCNTIiLz4KPC9zdmc+";